import { render, staticRenderFns } from "./institutionUpload.vue?vue&type=template&id=6174e4e4&scoped=true"
import script from "./institutionUpload.vue?vue&type=script&lang=js"
export * from "./institutionUpload.vue?vue&type=script&lang=js"
import style0 from "./institutionUpload.vue?vue&type=style&index=0&id=6174e4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6174e4e4",
  null
  
)

export default component.exports